var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAngleDownSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "angle-down-small",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "angle-down-small_2",
    d: "M16.3543 10.3543L12.3543 14.3543C12.2563 14.4523 12.1283 14.5003 12.0003 14.5003C11.8723 14.5003 11.7442 14.4513 11.6462 14.3543L7.64625 10.3543C7.45125 10.1593 7.45125 9.84223 7.64625 9.64723C7.84125 9.45223 8.15828 9.45223 8.35328 9.64723L11.9993 13.2932L15.6453 9.64723C15.8403 9.45223 16.1573 9.45223 16.3523 9.64723C16.5473 9.84223 16.5493 10.1583 16.3543 10.3543Z",
    fill: "#4F4D55"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleDownSmall);
export default __webpack_public_path__ + "static/media/angle-down-small.47be0d1e9ac17eec44a09b2587aaf476.svg";
export { ForwardRef as ReactComponent };